import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import propertyService from '../../services/property';

const initialState = {
  loading: false,
  propertyGroups: [],
  error: '',
  meta: {},
};

export const fetchPropertyGroups = createAsyncThunk(
  'property/fetchPropertyGroups',
  (params = {}) => {
    return propertyService.getAllGroups(params).then((res) => res);
  }
);

const propertyGroupSlice = createSlice({
  name: 'propertyGroup',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchPropertyGroups.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchPropertyGroups.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.propertyGroups = Array.isArray(payload?.data) ? payload.data : (payload?.data?.data ?? []);
      state.error = '';
      state.meta = payload?.meta ?? payload?.pagination ?? {};
    });
    builder.addCase(fetchPropertyGroups.rejected, (state, action) => {
      state.loading = false;
      state.propertyGroups = [];
      state.error = action.error.message;
      state.meta = {};
    });
  },
});

export default propertyGroupSlice.reducer;
